;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type IntegrationCallbackKeyParams = {
	authorizationCode: string | null;
	authorizationState?: string | null;
	workspaceId: string;
};

export const integrationQueryKeys = {
	all: ["integrations"] as const,
	authUrl: {
		gotoConnect: (workspaceId: string) =>
			["goto-connect", "authUrl", workspaceId] as const,
		podium: (workspaceId: string) =>
			["podium", "authUrl", workspaceId] as const,
		quickbooks: ["quickbooks", "authUrl"] as const,
		zoom: ["zoom", "authUrl"] as const,
	},
	gotoCallback: ({
		authorizationCode,
		authorizationState,
		workspaceId,
	}: IntegrationCallbackKeyParams) =>
		[
			...integrationQueryKeys.all,
			"goto",
			workspaceId,
			authorizationCode,
			authorizationState,
		] as const,
	podiumCallback: ({
		authorizationCode,
		authorizationState,
		workspaceId,
	}: IntegrationCallbackKeyParams) =>
		[
			...integrationQueryKeys.all,
			"podium",
			workspaceId,
			authorizationCode,
			authorizationState,
		] as const,
	providerInstructions: (provider: string) =>
		["provider-instructions", provider] as const,
	quickbooksCallback: ({
		authorizationCode,
		workspaceId,
	}: {
		authorizationCode: string | null;
		workspaceId: string;
	}) =>
		[
			...integrationQueryKeys.all,
			"quickbooks",
			workspaceId,
			authorizationCode,
		] as const,
	zoomCallback: ({
		authorizationCode,
		authorizationState,
		workspaceId,
	}: IntegrationCallbackKeyParams) =>
		[
			...integrationQueryKeys.all,
			"zoom",
			workspaceId,
			authorizationCode,
			authorizationState,
		] as const,
};
